import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

// ── Paleta e helpers ─────────────────────────────────────────
const C = { cyan: '#00CFFF', orange: '#FF8C00', dark: '#021235', surface: '#071629', purple: '#a78bfa' }

function Btn({ children, onClick, variant = 'primary', style = {} }) {
  const base = { display:'inline-flex', alignItems:'center', justifyContent:'center', gap:8, padding:'14px 28px', borderRadius:12, fontSize:15, fontWeight:800, cursor:'pointer', fontFamily:'Montserrat,sans-serif', border:'none', transition:'transform 0.15s, box-shadow 0.15s', letterSpacing:0.3 }
  const variants = {
    primary: { background:`linear-gradient(135deg,${C.cyan},#0099cc)`, color:'#fff', boxShadow:`0 4px 24px ${C.cyan}44` },
    orange:  { background:`linear-gradient(135deg,${C.orange},#e07000)`, color:'#fff', boxShadow:`0 4px 24px ${C.orange}44` },
    ghost:   { background:'rgba(255,255,255,0.06)', color:'rgba(255,255,255,0.75)', border:'1px solid rgba(255,255,255,0.15)' },
  }
  return (
    <button onClick={onClick} style={{ ...base, ...variants[variant], ...style }}
      onMouseEnter={e => { e.currentTarget.style.transform='translateY(-2px)'; e.currentTarget.style.boxShadow=`0 8px 32px ${variant==='primary'?C.cyan:C.orange}55` }}
      onMouseLeave={e => { e.currentTarget.style.transform='translateY(0)'; e.currentTarget.style.boxShadow=variants[variant].boxShadow||'' }}>
      {children}
    </button>
  )
}

// Ponto pulsante "ao vivo"
function LiveDot({ size = 10 }) {
  return (
    <span style={{ position:'relative', display:'inline-block', width:size, height:size, flexShrink:0 }}>
      <span style={{ position:'absolute', inset:0, borderRadius:'50%', background:'#ff4444', animation:'ping 1.4s ease-in-out infinite', opacity:0.6 }} />
      <span style={{ position:'absolute', inset:0, borderRadius:'50%', background:'#ff4444' }} />
      <style>{`@keyframes ping{0%{transform:scale(1);opacity:0.7}70%{transform:scale(2.2);opacity:0}100%{transform:scale(2.2);opacity:0}}`}</style>
    </span>
  )
}

// Contador animado
function Counter({ target, suffix = '' }) {
  const [val, setVal] = useState(0)
  useEffect(() => {
    let start = 0
    const step = Math.ceil(target / 40)
    const t = setInterval(() => {
      start += step
      if (start >= target) { setVal(target); clearInterval(t) }
      else setVal(start)
    }, 30)
    return () => clearInterval(t)
  }, [target])
  return <>{val.toLocaleString('pt-BR')}{suffix}</>
}

const PLANOS = [
  { id:'solo',    nome:'Solo',    preco:9.90,  cor:C.cyan,   badge:'7 dias grátis', features:['Buscar cifras na web ou por link','Transpor acordes','Setlists ilimitados','1 show ao vivo/mês'] },
  { id:'musico',  nome:'Músico',  preco:24.90, cor:C.orange, badge:'⭐ Popular',     features:['Tudo do Solo','4 shows ao vivo/mês','Importar PDF e Word','Importar por foto'] },
  { id:'maestro', nome:'Maestro', preco:39.90, cor:C.purple, badge:'7 dias grátis', features:['Tudo do Músico','Shows ilimitados','Importar por áudio MP3 (IA)'] },
]

export default function LandingPage() {
  const navigate = useNavigate()
  const [billing, setBilling] = useState('monthly')
  const [faqAberto, setFaqAberto] = useState(null)
  const isAnnual = billing === 'annual'

  const goAuth = () => navigate('/auth')

  return (
    <div style={{ background:C.dark, color:'#f0f0f0', fontFamily:'Montserrat,sans-serif', overflowX:'hidden' }}>

      {/* ══════════ NAV ══════════ */}
      <nav style={{ position:'sticky', top:0, zIndex:100, background:'rgba(2,18,53,0.92)', backdropFilter:'blur(16px)', borderBottom:'1px solid rgba(0,207,255,0.1)', padding:'12px 24px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <img src="/logo-app.png" alt="" style={{ width:36, height:36, objectFit:'contain' }} />
          <span style={{ fontWeight:900, fontSize:20, letterSpacing:0.5 }}>
            <span style={{ color:C.cyan }}>CIFRAS</span><span style={{ color:C.orange }}>BAND</span>
          </span>
        </div>
        <div style={{ display:'flex', gap:8, alignItems:'center' }}>
          <a href="#planos" style={{ color:'rgba(255,255,255,0.6)', fontSize:13, fontWeight:600, textDecoration:'none', padding:'8px 14px', display:'none' }}>Planos</a>
          <Btn variant="ghost" onClick={goAuth} style={{ padding:'9px 18px', fontSize:13 }}>Entrar</Btn>
          <Btn variant="orange" onClick={goAuth} style={{ padding:'9px 18px', fontSize:13 }}>Criar conta grátis →</Btn>
        </div>
      </nav>

      {/* ══════════ HERO ══════════ */}
      <section style={{ minHeight:'90vh', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', textAlign:'center', padding:'60px 20px 40px', position:'relative', overflow:'hidden' }}>

        {/* Glow de fundo */}
        <div style={{ position:'absolute', top:'20%', left:'50%', transform:'translateX(-50%)', width:600, height:600, borderRadius:'50%', background:`radial-gradient(circle,${C.cyan}18 0%,transparent 70%)`, pointerEvents:'none' }} />
        <div style={{ position:'absolute', bottom:'10%', left:'20%', width:300, height:300, borderRadius:'50%', background:`radial-gradient(circle,${C.orange}15 0%,transparent 70%)`, pointerEvents:'none' }} />

        {/* Badge ao vivo */}
        <div style={{ display:'inline-flex', alignItems:'center', gap:8, background:'rgba(255,68,68,0.12)', border:'1px solid rgba(255,68,68,0.3)', borderRadius:50, padding:'7px 16px', fontSize:12, fontWeight:700, color:'#ff6b6b', marginBottom:28, letterSpacing:0.5 }}>
          <LiveDot size={8} />
          SINCRONIZAÇÃO EM TEMPO REAL · EXCLUSIVO CIFRASBAND
        </div>

        {/* Logo grande */}
        <div style={{ display:'flex', alignItems:'center', gap:16, marginBottom:20 }}>
          <img src="/logo-app.png" alt="CifrasBand" style={{ width:72, height:72, objectFit:'contain', filter:'drop-shadow(0 0 24px rgba(0,207,255,0.5))' }} />
          <div style={{ textAlign:'left' }}>
            <div style={{ fontWeight:900, fontSize:42, lineHeight:1, letterSpacing:1 }}>
              <span style={{ color:C.cyan }}>CIFRAS</span><span style={{ color:C.orange }}>BAND</span>
            </div>
            <div style={{ fontSize:11, color:'rgba(0,207,255,0.6)', letterSpacing:4, fontWeight:600, marginTop:4 }}>
              SINCRONIA QUE SE OUVE
            </div>
          </div>
        </div>

        {/* Headline */}
        <h1 style={{ fontSize:'clamp(28px,6vw,52px)', fontWeight:900, lineHeight:1.12, marginBottom:20, maxWidth:720, margin:'0 auto 20px' }}>
          Sua banda toca junta,{' '}
          <span style={{ background:`linear-gradient(90deg,${C.cyan},${C.orange})`, WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' }}>
            mesmo de longe
          </span>
        </h1>

        {/* Sub */}
        <p style={{ fontSize:'clamp(14px,2.5vw,18px)', color:'rgba(255,255,255,0.6)', lineHeight:1.7, maxWidth:560, margin:'0 auto 36px' }}>
          Cifras, partituras e shows ao vivo sincronizados em tempo real.<br />
          <strong style={{ color:'rgba(255,255,255,0.85)' }}>O líder avança para a próxima música — todos os músicos veem a cifra atualizada no mesmo instante, em qualquer celular.</strong> Sem WhatsApp, sem confusão.
        </p>

        {/* CTAs */}
        <div style={{ display:'flex', gap:14, justifyContent:'center', flexWrap:'wrap', marginBottom:48 }}>
          <Btn variant="primary" onClick={goAuth} style={{ fontSize:16, padding:'16px 36px' }}>
            🎵 Começar grátis agora
          </Btn>
          <Btn variant="ghost" onClick={() => document.getElementById('como-funciona')?.scrollIntoView({ behavior:'smooth' })} style={{ fontSize:15 }}>
            Ver como funciona ↓
          </Btn>
        </div>

        {/* Trust signals */}
        <div style={{ display:'flex', gap:24, justifyContent:'center', flexWrap:'wrap', fontSize:12, color:'rgba(255,255,255,0.4)', fontWeight:600 }}>
          {['✓ Grátis para começar','✓ Sem cartão de crédito','✓ Cancele quando quiser'].map(t => (
            <span key={t} style={{ color:'rgba(0,207,255,0.7)' }}>{t}</span>
          ))}
        </div>

        {/* Mockup visual — cards de músicos sincronizados */}
        <div style={{ marginTop:56, display:'flex', gap:12, justifyContent:'center', flexWrap:'wrap', maxWidth:600, margin:'56px auto 0' }}>
          {[
            { nome:'Lucas', inst:'Violão', cor:C.cyan,   cifra:'G  D  Em  C', musica:'Oceans — Hillsong' },
            { nome:'Ana',   inst:'Teclado',cor:C.orange, cifra:'G  D  Em  C', musica:'Oceans — Hillsong' },
            { nome:'Pedro', inst:'Baixo',  cor:C.purple, cifra:'G  D  Em  C', musica:'Oceans — Hillsong' },
          ].map((m, i) => (
            <div key={i} style={{ background:'rgba(255,255,255,0.05)', border:`1px solid ${m.cor}33`, borderRadius:14, padding:'14px 16px', width:160, textAlign:'left', position:'relative' }}>
              <div style={{ display:'flex', alignItems:'center', gap:6, marginBottom:8 }}>
                <div style={{ width:28, height:28, borderRadius:'50%', background:`${m.cor}33`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:800, color:m.cor }}>{m.nome[0]}</div>
                <div>
                  <div style={{ fontSize:11, fontWeight:700 }}>{m.nome}</div>
                  <div style={{ fontSize:9, color:'rgba(255,255,255,0.4)' }}>{m.inst}</div>
                </div>
                <LiveDot size={6} />
              </div>
              <div style={{ fontFamily:'monospace', fontSize:13, color:m.cor, fontWeight:700, marginBottom:4 }}>{m.cifra}</div>
              <div style={{ fontSize:9, color:'rgba(255,255,255,0.35)' }}>{m.musica}</div>
            </div>
          ))}
        </div>
        <div style={{ fontSize:11, color:'rgba(0,207,255,0.5)', marginTop:12, fontWeight:600, letterSpacing:1 }}>
          🔴 AO VIVO — TODOS VÊM A MESMA CIFRA
        </div>
      </section>

      {/* ══════════ NÚMEROS ══════════ */}
      <section style={{ background:'rgba(0,207,255,0.04)', borderTop:'1px solid rgba(0,207,255,0.1)', borderBottom:'1px solid rgba(0,207,255,0.1)', padding:'32px 20px' }}>
        <div style={{ maxWidth:700, margin:'0 auto', display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:20, textAlign:'center' }}>
          {[
            { val:500, suf:'+', label:'Músicos cadastrados' },
            { val:1200, suf:'+', label:'Cifras compartilhadas' },
            { val:98, suf:'%', label:'Satisfação dos grupos' },
          ].map((s, i) => (
            <div key={i}>
              <div style={{ fontSize:'clamp(24px,5vw,38px)', fontWeight:900, color:C.cyan, fontFamily:'Montserrat,sans-serif' }}>
                <Counter target={s.val} suffix={s.suf} />
              </div>
              <div style={{ fontSize:12, color:'rgba(255,255,255,0.5)', marginTop:4 }}>{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ══════════ DOR → SOLUÇÃO ══════════ */}
      <section style={{ padding:'72px 20px', maxWidth:680, margin:'0 auto', textAlign:'center' }}>
        <div style={{ fontSize:13, color:C.orange, fontWeight:700, letterSpacing:2, textTransform:'uppercase', marginBottom:12 }}>O problema que a gente resolve</div>
        <h2 style={{ fontSize:'clamp(22px,4vw,34px)', fontWeight:900, lineHeight:1.25, marginBottom:20 }}>
          Quanto tempo você perde antes de cada ensaio?
        </h2>
        <p style={{ color:'rgba(255,255,255,0.6)', fontSize:15, lineHeight:1.8, marginBottom:40 }}>
          "Qual tom vamos tocar hoje?" · "Manda a cifra no WhatsApp" · "Alguém tem o PDF?"<br />
          <strong style={{ color:'rgba(255,255,255,0.85)' }}>Isso acaba com o CifrasBand.</strong>
        </p>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, textAlign:'left' }}>
          {[
            { antes:'❌ Cifras espalhadas no WhatsApp', depois:'✓ Tudo no grupo, organizado' },
            { antes:'❌ Cada músico em um tom diferente', depois:'✓ Tom registrado e sincronizado' },
            { antes:'❌ "Qual música é a próxima?"', depois:'✓ Show ao vivo — todos na mesma' },
            { antes:'❌ PDFs perdidos no e-mail', depois:'✓ Partituras por instrumento no Classic' },
          ].map((r, i) => (
            <div key={i} style={{ background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.07)', borderRadius:12, padding:'14px 16px' }}>
              <div style={{ fontSize:12, color:'rgba(255,100,100,0.8)', marginBottom:6 }}>{r.antes}</div>
              <div style={{ fontSize:12, color:'rgba(0,207,255,0.9)', fontWeight:700 }}>{r.depois}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ══════════ COMO FUNCIONA ══════════ */}
      <section id="como-funciona" style={{ background:'rgba(7,22,41,0.8)', borderTop:'1px solid rgba(255,255,255,0.06)', borderBottom:'1px solid rgba(255,255,255,0.06)', padding:'72px 20px' }}>
        <div style={{ maxWidth:640, margin:'0 auto', textAlign:'center' }}>
          <div style={{ fontSize:13, color:C.cyan, fontWeight:700, letterSpacing:2, textTransform:'uppercase', marginBottom:12 }}>Como funciona</div>
          <h2 style={{ fontSize:'clamp(22px,4vw,34px)', fontWeight:900, marginBottom:48 }}>Em 3 passos — do zero ao show</h2>

          <div style={{ display:'flex', flexDirection:'column', gap:24 }}>
            {[
              { n:'01', cor:C.cyan,   titulo:'Crie o grupo e adicione cifras', desc:'Monte o repertório do seu grupo. Importe de qualquer site de cifras da internet, pelo áudio da música ou faça upload de PDF e Word.' },
              { n:'02', cor:C.orange, titulo:'Monte o setlist da semana', desc:'Organize a ordem das músicas, registre os tons de cada integrante. Pronto para o ensaio.' },
              { n:'03', cor:C.purple, titulo:'Inicie o show ao vivo', desc:'Com um toque, todos os músicos conectados veem a mesma cifra. Você avança — eles acompanham. Em tempo real.' },
            ].map((p, i) => (
              <div key={i} style={{ display:'flex', gap:20, textAlign:'left', alignItems:'flex-start' }}>
                <div style={{ width:52, height:52, borderRadius:14, background:`${p.cor}15`, border:`2px solid ${p.cor}44`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, fontWeight:900, fontSize:18, color:p.cor, fontFamily:'Montserrat,sans-serif' }}>{p.n}</div>
                <div>
                  <div style={{ fontWeight:800, fontSize:16, marginBottom:6 }}>{p.titulo}</div>
                  <div style={{ fontSize:13, color:'rgba(255,255,255,0.55)', lineHeight:1.6 }}>{p.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <div style={{ marginTop:40 }}>
            <Btn variant="primary" onClick={goAuth} style={{ width:'100%', maxWidth:340, fontSize:15 }}>
              Quero experimentar grátis →
            </Btn>
          </div>
        </div>
      </section>

      {/* ══════════ FEATURES ══════════ */}
      <section style={{ padding:'72px 20px', maxWidth:720, margin:'0 auto' }}>
        <div style={{ textAlign:'center', marginBottom:48 }}>
          <div style={{ fontSize:13, color:C.orange, fontWeight:700, letterSpacing:2, textTransform:'uppercase', marginBottom:12 }}>Recursos</div>
          <h2 style={{ fontSize:'clamp(22px,4vw,34px)', fontWeight:900 }}>Tudo que sua banda precisa</h2>
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(280px,1fr))', gap:16 }}>
          {[
            { icon:'🎸', cor:C.cyan,   titulo:'Show ao vivo em tempo real', desc:'O admin controla a música. Todos os músicos conectados veem a mesma cifra instantaneamente — via WebSocket.' },
            { icon:'🤖', cor:C.orange, titulo:'Import. por áudio com IA', desc:'Coloca o áudio da música, a IA transcreve e entrega a cifra completa. Novidades no repertório sem trabalho manual.' },
            { icon:'🎼', cor:C.purple, titulo:'CifrasBand Classic', desc:'Módulo exclusivo para orquestras. Partituras em PDF por instrumento, maestro controla a página de todos ao vivo.' },
            { icon:'🎵', cor:C.cyan,   titulo:'Setlists inteligentes', desc:'Monte a ordem do culto, ensaio ou show. Registre tons, adicione notas e repita a mesma lista quando quiser.' },
            { icon:'🔄', cor:C.orange, titulo:'Transposição de acordes', desc:'Mude o tom com um toque. Os acordes transpõem automaticamente para cada músico no seu tom preferido.' },
            { icon:'👥', cor:C.purple, titulo:'Grupos ilimitados', desc:'Crie quantos grupos precisar — banda, grupo de louvor, orquestra. Cada grupo tem seu próprio feed e setlists.' },
          ].map((f, i) => (
            <div key={i} style={{ background:'rgba(255,255,255,0.03)', border:`1px solid ${f.cor}22`, borderRadius:16, padding:'22px 20px', transition:'border-color 0.2s, transform 0.2s' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor=`${f.cor}55`; e.currentTarget.style.transform='translateY(-3px)' }}
              onMouseLeave={e => { e.currentTarget.style.borderColor=`${f.cor}22`; e.currentTarget.style.transform='translateY(0)' }}>
              <div style={{ fontSize:32, marginBottom:12 }}>{f.icon}</div>
              <div style={{ fontWeight:800, fontSize:15, marginBottom:8, color:f.cor }}>{f.titulo}</div>
              <div style={{ fontSize:13, color:'rgba(255,255,255,0.5)', lineHeight:1.6 }}>{f.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ══════════ CLASSIC SPOTLIGHT ══════════ */}
      <section style={{ background:`linear-gradient(135deg,rgba(167,139,250,0.08),rgba(2,18,53,0.8))`, border:'1px solid rgba(167,139,250,0.2)', borderRadius:24, margin:'0 20px 72px', padding:'48px 32px', maxWidth:680, marginLeft:'auto', marginRight:'auto' }}>
        <div style={{ display:'flex', gap:16, alignItems:'center', marginBottom:20 }}>
          <img src="/logo-app.png" alt="" style={{ width:48, height:48, objectFit:'contain', filter:'hue-rotate(270deg) brightness(1.2)' }} />
          <div>
            <div style={{ fontWeight:900, fontSize:22 }}>
              <span style={{ color:C.cyan }}>CIFRAS</span><span style={{ color:C.orange }}>BAND</span>
              <span style={{ color:C.purple, marginLeft:8, fontSize:16 }}>CLASSIC</span>
            </div>
            <div style={{ fontSize:11, color:'rgba(167,139,250,0.7)', letterSpacing:2, fontWeight:600 }}>PARA ORQUESTRAS E CORAIS</div>
          </div>
        </div>
        <h3 style={{ fontSize:'clamp(18px,3vw,26px)', fontWeight:900, marginBottom:12, lineHeight:1.3 }}>
          Partituras sincronizadas. Maestro no comando.
        </h3>
        <p style={{ color:'rgba(255,255,255,0.6)', fontSize:14, lineHeight:1.7, marginBottom:24 }}>
          Cada músico vê a partitura do <strong style={{ color:C.purple }}>seu próprio instrumento</strong> no celular. O maestro vira a página — todos acompanham. Acabou a papelada, acabou o atraso.
        </p>
        <div style={{ display:'flex', gap:10, flexWrap:'wrap', marginBottom:28 }}>
          {['PDF por instrumento','Sync de página ao vivo','Maestro = Admin do grupo','Funciona offline (PDF cached)'].map(t => (
            <span key={t} style={{ background:'rgba(167,139,250,0.12)', border:'1px solid rgba(167,139,250,0.25)', color:C.purple, fontSize:11, fontWeight:700, padding:'5px 12px', borderRadius:20 }}>{t}</span>
          ))}
        </div>
        <Btn variant="ghost" onClick={goAuth} style={{ borderColor:'rgba(167,139,250,0.4)', color:C.purple }}>
          🎼 Conhecer o Classic →
        </Btn>
      </section>

      {/* ══════════ DEPOIMENTOS ══════════ */}
      <section style={{ padding:'0 20px 72px', maxWidth:700, margin:'0 auto' }}>
        <div style={{ textAlign:'center', marginBottom:36 }}>
          <div style={{ fontSize:13, color:C.cyan, fontWeight:700, letterSpacing:2, textTransform:'uppercase', marginBottom:12 }}>Depoimentos</div>
          <h2 style={{ fontSize:'clamp(20px,4vw,30px)', fontWeight:900 }}>Quem já usa não quer voltar atrás</h2>
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(260px,1fr))', gap:14 }}>
          {[
            { nome:'Marcos V.', cargo:'Líder de Louvor', texto:'"O show ao vivo mudou completamente nosso culto. Acabou aquela correria de "qual música é agora?" no palco."' },
            { nome:'Juliana R.', cargo:'Maestrina', texto:'"Com o Classic, cada músico da orquestra vê sua partitura no celular. Economizou impressão e tempo de distribuição."' },
            { nome:'Rafael S.', cargo:'Guitarrista', texto:'"A importação por áudio é absurda. Botei a música nova que o pastor pediu na sexta — na manhã de domingo já tínhamos a cifra."' },
          ].map((d, i) => (
            <div key={i} style={{ background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:14, padding:'20px' }}>
              <div style={{ color:'rgba(255,207,0,0.8)', fontSize:14, marginBottom:10 }}>★★★★★</div>
              <p style={{ fontSize:13, color:'rgba(255,255,255,0.7)', lineHeight:1.6, marginBottom:14, fontStyle:'italic' }}>{d.texto}</p>
              <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                <div style={{ width:32, height:32, borderRadius:'50%', background:`${C.orange}33`, display:'flex', alignItems:'center', justifyContent:'center', fontWeight:800, fontSize:13, color:C.orange }}>{d.nome[0]}</div>
                <div>
                  <div style={{ fontSize:13, fontWeight:700 }}>{d.nome}</div>
                  <div style={{ fontSize:11, color:'rgba(255,255,255,0.4)' }}>{d.cargo}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ══════════ PLANOS ══════════ */}
      <section id="planos" style={{ padding:'0 20px 72px', maxWidth:700, margin:'0 auto' }}>
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <div style={{ fontSize:13, color:C.orange, fontWeight:700, letterSpacing:2, textTransform:'uppercase', marginBottom:12 }}>Planos e Preços</div>
          <h2 style={{ fontSize:'clamp(22px,4vw,34px)', fontWeight:900, marginBottom:8 }}>Comece grátis. Escale quando crescer.</h2>
          <p style={{ color:'rgba(255,255,255,0.5)', fontSize:14, marginBottom:24 }}>Cancele quando quiser · Sem taxa de cancelamento</p>

          {/* Toggle */}
          <div style={{ display:'flex', justifyContent:'center' }}>
            <div style={{ display:'inline-flex', background:'rgba(255,255,255,0.06)', borderRadius:50, padding:4, gap:4 }}>
              {[['monthly','Mensal'],['annual','Anual']].map(([v,l]) => (
                <button key={v} onClick={() => setBilling(v)}
                  style={{ padding:'8px 22px', borderRadius:50, border:'none', cursor:'pointer', fontSize:13, fontWeight:700, fontFamily:'Montserrat,sans-serif', transition:'all 0.2s',
                    background: billing===v ? C.orange : 'transparent',
                    color: billing===v ? '#fff' : 'rgba(255,255,255,0.4)' }}>
                  {l}
                  {v==='annual' && <span style={{ marginLeft:6, fontSize:10, background:'rgba(74,222,128,0.15)', color:'#4ade80', padding:'2px 6px', borderRadius:20 }}>−10%</span>}
                </button>
              ))}
            </div>
          </div>
          {isAnnual && <div style={{ fontSize:12, color:'#4ade80', marginTop:8, fontWeight:600 }}>💡 Economia de 10% · cobrado anualmente</div>}
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(230px,1fr))', gap:12 }}>
          {PLANOS.map(p => {
            const preco = isAnnual && p.preco > 0 ? +(p.preco * 0.9).toFixed(2) : p.preco
            const [int, dec] = preco > 0 ? preco.toFixed(2).split('.') : ['0','']
            return (
              <div key={p.id} style={{ background: p.badge ? `linear-gradient(135deg,rgba(255,140,0,0.07),rgba(0,207,255,0.07))` : 'rgba(255,255,255,0.03)', border:`1px solid ${p.cor}${p.badge?'55':'22'}`, borderRadius:16, padding:'22px 18px', position:'relative', transition:'transform 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.transform='translateY(-4px)'}
                onMouseLeave={e => e.currentTarget.style.transform='translateY(0)'}>
                {p.badge && <div style={{ position:'absolute', top:-11, left:'50%', transform:'translateX(-50%)', background:p.cor, color: p.id==='pro'?C.dark:'#fff', fontSize:10, fontWeight:900, padding:'4px 14px', borderRadius:20, whiteSpace:'nowrap', fontFamily:'Montserrat,sans-serif' }}>{p.badge}</div>}
                <div style={{ color:p.cor, fontWeight:900, fontSize:17, marginBottom:10 }}>{p.nome}</div>
                <div style={{ marginBottom:16 }}>
                  {preco === 0 ? (
                    <span style={{ fontSize:28, fontWeight:900 }}>Grátis</span>
                  ) : (
                    <>
                      {isAnnual && <div style={{ fontSize:11, color:'rgba(255,255,255,0.3)', textDecoration:'line-through', marginBottom:2 }}>R${p.preco.toFixed(2).replace('.',',')}/mês</div>}
                      <span style={{ fontSize:11, color:'rgba(255,255,255,0.5)' }}>R$</span>
                      <span style={{ fontSize:30, fontWeight:900 }}>{int}</span>
                      <span style={{ fontSize:16 }}>,{dec}</span>
                      <span style={{ fontSize:11, color:'rgba(255,255,255,0.4)' }}>/mês</span>
                    </>
                  )}
                </div>
                <div style={{ display:'flex', flexDirection:'column', gap:7, marginBottom:20 }}>
                  {p.features.map((f, i) => (
                    <div key={i} style={{ fontSize:12, color:'rgba(255,255,255,0.7)', display:'flex', gap:6, alignItems:'flex-start' }}>
                      <span style={{ color:'#4ade80', flexShrink:0 }}>✓</span> {f}
                    </div>
                  ))}
                </div>
                <button onClick={goAuth}
                  style={{ width:'100%', padding:'12px', borderRadius:10, border:'none', fontSize:13, fontWeight:800, cursor:'pointer', fontFamily:'Montserrat,sans-serif',
                    background: p.badge ? `linear-gradient(135deg,${C.orange},#e07000)` : `${p.cor}18`,
                    color: p.badge ? '#fff' : p.cor,
                    boxShadow: p.badge ? `0 4px 20px ${C.orange}44` : 'none' }}>
                  {p.preco === 0 ? 'Criar conta grátis →' : isAnnual ? 'Assinar anual →' : 'Assinar mensal →'}
                </button>
              </div>
            )
          })}
        </div>
      </section>

      {/* ══════════ FAQ ══════════ */}
      <section style={{ padding:'0 20px 72px', maxWidth:640, margin:'0 auto' }}>
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <h2 style={{ fontSize:'clamp(20px,4vw,30px)', fontWeight:900 }}>Dúvidas frequentes</h2>
        </div>
        {[
          ['O show ao vivo é realmente em tempo real?', 'Sim. Usando WebSocket via Supabase Realtime, a latência é menor que 200ms. Quando o admin muda a música, todos os músicos veem instantaneamente — sem refresh.'],
          ['Funciona sem internet durante o show?', 'O app precisa de internet para o sync ao vivo. Para partituras (Classic), os PDFs ficam em cache depois do primeiro carregamento.'],
          ['Posso usar a mesma conta Stripe que já tenho?', 'Sim, o CifrasBand usa uma conta Stripe separada por produto. Se você já tem conta Stripe, basta criar novos produtos para o CifrasBand.'],
          ['Preciso instalar alguma coisa?', 'Não. O CifrasBand é um PWA — funciona direto pelo navegador em qualquer celular. Pode instalar na tela inicial como um app, sem precisar da App Store.'],
          ['O Classic (orquestras) é incluso?', 'O módulo Classic está disponível mediante licença admin. Contate o suporte para ativar o Classic no seu grupo.'],
          ['Posso cancelar quando quiser?', 'Sim. Sem fidelidade e sem multa. O plano continua ativo até o fim do período já pago.'],
        ].map(([p, r], i) => (
          <div key={i} style={{ borderBottom:'1px solid rgba(255,255,255,0.07)', overflow:'hidden' }}>
            <button onClick={() => setFaqAberto(faqAberto===i ? null : i)}
              style={{ width:'100%', padding:'18px 0', background:'none', border:'none', color:'#f0f0f0', fontSize:14, fontWeight:700, cursor:'pointer', display:'flex', justifyContent:'space-between', alignItems:'center', gap:12, fontFamily:'Montserrat,sans-serif', textAlign:'left' }}>
              {p}
              <span style={{ color:C.cyan, fontSize:18, flexShrink:0, transition:'transform 0.2s', transform:faqAberto===i?'rotate(45deg)':'rotate(0)' }}>+</span>
            </button>
            {faqAberto === i && (
              <div style={{ paddingBottom:18, fontSize:13, color:'rgba(255,255,255,0.6)', lineHeight:1.7 }}>{r}</div>
            )}
          </div>
        ))}
      </section>

      {/* ══════════ CTA FINAL ══════════ */}
      <section style={{ background:`linear-gradient(135deg,rgba(0,207,255,0.08),rgba(255,140,0,0.08))`, border:'1px solid rgba(0,207,255,0.15)', borderRadius:24, margin:'0 20px 64px', padding:'56px 32px', textAlign:'center', maxWidth:640, marginLeft:'auto', marginRight:'auto' }}>
        <img src="/icon-192.png" alt="" style={{ width:64, height:64, objectFit:'contain', borderRadius:16, marginBottom:20, boxShadow:`0 0 32px ${C.cyan}44` }} />
        <h2 style={{ fontSize:'clamp(22px,4vw,34px)', fontWeight:900, marginBottom:12 }}>
          Pronto para a primeira<br />
          <span style={{ background:`linear-gradient(90deg,${C.cyan},${C.orange})`, WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' }}>
            sincronia perfeita?
          </span>
        </h2>
        <p style={{ color:'rgba(255,255,255,0.55)', fontSize:15, marginBottom:32, lineHeight:1.6 }}>
          Crie sua conta grátis agora. Sem cartão de crédito.<br />
          Leva menos de 1 minuto para começar.
        </p>
        <Btn variant="orange" onClick={goAuth} style={{ fontSize:16, padding:'16px 40px', width:'100%', maxWidth:340 }}>
          🎵 Criar conta grátis →
        </Btn>
        <div style={{ marginTop:16, fontSize:12, color:'rgba(255,255,255,0.35)' }}>
          🔒 Pagamento seguro via Stripe · Dados protegidos · Sem spam
        </div>
      </section>

      {/* ══════════ FOOTER ══════════ */}
      <footer style={{ borderTop:'1px solid rgba(255,255,255,0.07)', padding:'32px 20px', textAlign:'center' }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:10, marginBottom:16 }}>
          <img src="/logo-app.png" alt="" style={{ width:28, height:28, objectFit:'contain' }} />
          <span style={{ fontWeight:900, fontSize:16 }}>
            <span style={{ color:C.cyan }}>CIFRAS</span><span style={{ color:C.orange }}>BAND</span>
          </span>
        </div>
        <div style={{ fontSize:12, color:'rgba(255,255,255,0.3)', lineHeight:2 }}>
          SINCRONIA QUE SE OUVE<br />
          <a href="/privacidade.html" style={{ color:'rgba(255,255,255,0.3)', textDecoration:'none' }}>Privacidade</a>
          {' · '}
          <span onClick={goAuth} style={{ cursor:'pointer', color:'rgba(255,255,255,0.3)' }}>Entrar</span>
          {' · '}
          <span onClick={goAuth} style={{ cursor:'pointer', color:'rgba(255,255,255,0.3)' }}>Criar conta</span>
        </div>
      </footer>
    </div>
  )
}
